import { observable, computed, makeObservable } from 'mobx';
import {t} from 'shared/core';
import {DomainObject, oneOf} from 'shared/store';
import User from '../users/User';
import CompanyDocument from './CompanyDocument';

class NotificationRecipient extends DomainObject {
  recipientType;
  user;
  companyDocument;

  _relations = {
    user: User,
    companyDocument: CompanyDocument,
    recipientType: oneOf(['manager', 'specific_user'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      recipientType: observable,
      user: observable,
      companyDocument: observable,
      value: computed,
      name: computed
    });

    this.merge(other);
  }

  get value() {
    if (this.recipientType === 'specific_user') return this.user.id;

    return this.recipientType;
  }

  get name() {
    if(this.recipientType === 'specific_user') return this.user.name;

    return t('models.company_document.notification_recipients.manager');
  }
}

export default NotificationRecipient;
